import { Avatar, Select, Space } from 'antd';
import { useAgents } from '../features/email/api';

export function AgentSelect({ value, onChange, disabled, size }: { value?: string | null; onChange?: (v: string | null) => void; disabled?: boolean; size?: 'small' | 'middle' }) {
  const agents = useAgents();
  return (
    <Select
      allowClear
      showSearch
      optionFilterProp="label"
      size={size}
      disabled={disabled}
      value={value ?? undefined}
      loading={agents.isLoading}
      placeholder={agents.isLoading ? 'Loading agents…' : agents.data && !agents.data.some((a) => a.isActive) ? 'No active agents yet' : 'Agent'}
      notFoundContent="No agents. Create one under Admin → Agents."
      onChange={(v) => onChange?.((v as string | undefined) ?? null)}
      // inactive agents stay listed so a saved choice keeps its name, but cannot be picked
      options={(agents.data ?? []).map((a) => ({ value: a.id, label: a.isActive ? a.name : `${a.name} (inactive)`, avatarUrl: a.avatarUrl, disabled: !a.isActive }))}
      optionRender={(o) => (
        <Space>
          <Avatar size="small" src={(o.data as { avatarUrl: string | null }).avatarUrl ?? undefined} style={{ background: '#722ed1' }}>{String(o.label)[0]}</Avatar>
          {o.label}
        </Space>
      )}
    />
  );
}
